import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const createStyles = (screenWidth: number) =>
  StyleSheet.create({
    container: {
      paddingVertical: 16,
      paddingHorizontal: 16,
      flex: 1,
      backgroundColor: `#FFF`, // Use dynamic background color
    },
    dataFieldsContainer: {
      flex: 1,
      gap: 24,
    },
    title: {
      color: themes.light.gray_blue[1],
    },
    buttonGroup: {
      flexDirection: 'row',
      width: '100%',
      gap: 12,
    },
    navButtonGroup: {
      flexDirection: 'row',
      justifyContent: 'center',
      gap: 24,
    },
    addressContainer: {
      gap: 12,
      marginBottom: 8,
    },
    garagingAddressContainer: {
      gap: 12,
      marginBottom: 8,
    },
    mailingAddressContainer: {
      gap: 12,
      marginBottom: 8,
    },
    prevExperianceContainer: {
      gap: 12,
      marginBottom: 8,
    },
    buttonContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 8,
      width: '100%',
      paddingVertical: 12,
    },
    buttonWrapper1: {
      flex: 1,
      maxWidth: '33%',
    },
    buttonWrapper2: {
      flex: 1,
      maxWidth: '67%',
    },
    radioButton: {
      width: (screenWidth / 2 - 8) / 2,
    },
  });
